import { useMemo } from "react";
import { Formik, Form } from "formik";
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
} from "@material-tailwind/react";
import FormikCheckbox from "components/form/formik-checkbox";
import { sortThemesByName } from "../utils/sort-themes";

export default function RemoveFromThemeDialog({
    open,
    onClose,
    themes = [], // [{ id, name }]
    responses = [],
    onRemoveFromTheme, // (selectedThemeIds, responses) => {}
}) {
    const handleClose = () => {
        onClose();
    };
    const sortedThemes = useMemo(() => sortThemesByName(themes), [themes]);

    const handleSubmit = (values) => {
        const selectedThemeIds = Object.entries(values)
            .filter(([_, checked]) => checked === true)
            .map(([id]) => id);

        if (selectedThemeIds.length > 0) {
            onRemoveFromTheme(selectedThemeIds, responses);
            onClose();
        }
    };

    return (
        <Dialog open={open} handler={handleClose} className="dialog">
            <DialogHeader className="dialog__header">
                <Typography variant="h4">Remove from Theme</Typography>
            </DialogHeader>

            <Formik
                initialValues={sortedThemes.reduce(
                    (acc, theme) => ({ ...acc, [theme.id]: false }),
                    {},
                )}
                onSubmit={handleSubmit}
            >
                {({ values }) => (
                    <Form>
                        <DialogBody className="dialog__body">
                            <div className="dialog__section max-h-64 overflow-y-auto space-y-2">
                                {sortedThemes.map((theme) => (
                                    <div
                                        key={theme.id}
                                        className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-md"
                                    >
                                        <FormikCheckbox
                                            name={theme.id.toString()}
                                            label={theme.name}
                                            className="text-primary font-body"
                                            labelProps={{
                                                className:
                                                    "text-primary font-body",
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </DialogBody>

                        <DialogFooter className="dialog__footer">
                            <Button
                                type="button"
                                className="btn btn--danger"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                className="btn btn--primary"
                                disabled={!Object.values(values).some((v) => v)}
                            >
                                Remove from Theme
                            </Button>
                        </DialogFooter>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
